import * as _m0 from "protobufjs/minimal";
import { GetDashboardMetricsRequest, GetDashboardMetricsResponse } from "../getdashboardmetrics";
import { withAuthRetry } from '../utils/authRetry';
import { getServiceUrl } from '../utils/api';

export async function getDashboardMetrics(request: GetDashboardMetricsRequest, accessToken: string, setAccessToken: (token: string | null) => void, logout: () => void): Promise<GetDashboardMetricsResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const url = getServiceUrl('adminservice', 'getdashboardmetrics');

        const requestBody = GetDashboardMetricsRequest.encode(request).finish();

        const response = await fetch(
            url, {
            method: 'POST',
            headers,
            body: JSON.stringify({
                startDate: request.startDate,
                endDate: request.endDate,
                hideInternal: request.hideInternal
            })
        }
        );
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): GetDashboardMetricsResponse => {
        return GetDashboardMetricsResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}
